
const images = [
  {
    src: "/image/event/event1.jpg",
    caption: "Image 1 caption"
  },
  {
    src: "/image/event/event2.jpg",
    caption: "Image 2 caption"
  },
  {
    src: "/image/event/event3.jpg",
    caption: "Image 3 caption"
  },
  {
    src: "/image/event/event4.jpg",
    caption: "Image 4 caption"
  },
  {
    src: "/image/event/event5.jpg",
    caption: "Image 5 caption"
  },
];

const Gallery = () => {
  return (
    <div className="container mx-auto px-5 py-2 lg:px-32 lg:pt-24">
      <div className="-m-1 flex flex-wrap md:-m-2">
        {images.map((image, index) => (
          <div
            key={index}
            className="w-full sm:w-1/2 md:w-1/2 lg:w-1/2 xl:w-1/2 p-1 md:p-2 mb-6"
          >
            <img
              className="block mx-auto h-full object-cover object-center rounded-lg shadow-md"
              src={image.src}
              alt={`Gallery Image ${index + 1}`}
            />
            <p className="text-center mt-2">{image.caption}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Gallery;
